import {
  Transforms,
  Editor,
  Node,
  Text
} from 'slate';
import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import types from '../../elements/types';

import HelptapEditor from '../';

export function buildNode(options = {}) {

  return basicEditorValueSerializer.utilities.node.carousel.buildNode(options);

}

export function buildItemNode(options = {}) {

  return basicEditorValueSerializer.utilities.node.carouselItem.buildNode(options);

}

export function buildNodeFromRawFiles(rawFiles) {

  return basicEditorValueSerializer.utilities.node.carousel.buildNodeFromRawFiles(rawFiles);

}

export function insert(editor, rawFiles) {

  const node = buildNodeFromRawFiles(rawFiles);

  HelptapEditor.insertNode(editor, node);

}

export function getSettings(node) {

  return basicEditorValueSerializer.utilities.node.carousel.getSettings(node);

}

export function getContainerStyleObject(settings) {

  return basicEditorValueSerializer.utilities.node.carousel.getContainerStyleObject(settings);

}

export function updateSettings(editor, carouselPath, settings) {

  const carouselNode = Editor.node(editor, carouselPath)[0];

  HelptapEditor.setAttributes(editor, {
    properties: {
      ...(carouselNode.properties || {}),
      ...settings
    }
  }, carouselPath);

}

export function appendItems(editor, carouselPath, carouselId, rawFiles) {

  const carouselNode = Editor.node(editor, carouselPath)[0];
  const carouselProperties = carouselNode.properties || {};
  const itemStyles = carouselProperties.carouselItemStyles || {};
  const insertIndex = carouselNode.children.length;

  Editor.withoutNormalizing(editor, function insertItems() {

    rawFiles.forEach(function insertItem(rawFile, offset) {

      const item = buildItemNode({ rawFile, carouselId, styles: itemStyles });

      Transforms.insertNodes(editor, item, { at: [...carouselPath, insertIndex + offset] });

    });

  });

}

export function extractItemStyles(itemNode) {

  return basicEditorValueSerializer.utilities.node.carouselItem.extractStyles(itemNode);

}

export function removeEmptyCarousel(editor, carouselPath) {

  const children = Array.from(Node.children(editor, carouselPath));

  for (const [childNode] of children) {

    if (childNode.type === types.CAROUSEL_ITEM) {
      return false;
    }

  }

  Transforms.removeNodes(editor, { at: carouselPath });

  return true;

}

export function normalizeCarouselChildren(editor, carouselPath) {

  const children = Array.from(Node.children(editor, carouselPath));

  let carouselItemCount = 0;

  for (const [childNode] of children) {

    if (childNode.type === types.CAROUSEL_ITEM) {
      carouselItemCount++;
    }

  }

  for (const [childNode, childPath] of children) {

    if (childNode.type === types.CAROUSEL_ITEM) {
      continue;
    }

    if (Text.isText(childNode) === true && carouselItemCount === 0) {
      continue;
    }

    Transforms.removeNodes(editor, { at: childPath });

    return true;

  }

  return false;

}

export function syncItemStyles(editor, carouselNode, carouselPath, itemNode) {

  const itemStyles = extractItemStyles(itemNode);
  const carouselProperties = carouselNode.properties || {};
  const currentStyles = carouselProperties.carouselItemStyles || {};

  if (JSON.stringify(itemStyles) === JSON.stringify(currentStyles)) {
    return false;
  }

  Editor.withoutNormalizing(editor, function applyItemStyles() {

    HelptapEditor.setAttributes(editor, {
      properties: {
        ...carouselProperties,
        carouselItemStyles: itemStyles
      }
    }, carouselPath);

    for (const [, childPath] of Node.children(editor, carouselPath)) {
      HelptapEditor.setAttributes(editor, itemStyles, childPath);
    }

  });

  return true;

}
